/* A contact's channel types (CT-2) — what the Contacts table and the contact modal share: the seven
   types the API takes, their glyph (spec/02's icon map), their label key, and where a value links.

   No brand glyph exists in @ant-design/icons for Telegram or Viber, so they take a neutral one and
   always carry the type's NAME (tooltip + accessible name): the glyph alone is never the label.
   A value is stored as the user typed it — a phone is NOT normalised to E.164. Phone and Viber dial
   (`tel:`, with everything but digits and `+` stripped from the link only; the text shows as typed),
   an e-mail mails, a website opens in a new browser tab; the others are text. */

import { EllipsisOutlined, GlobalOutlined, InstagramOutlined, MailOutlined, MessageOutlined, PhoneOutlined, SendOutlined } from "@ant-design/icons";

export const CHANNEL_TYPES = ["phone", "email", "viber", "telegram", "instagram", "website", "other"];

export const CHANNEL_ICON = {
  phone: PhoneOutlined,
  email: MailOutlined,
  instagram: InstagramOutlined,
  telegram: SendOutlined,
  viber: MessageOutlined,
  website: GlobalOutlined,
  other: EllipsisOutlined,
};

export const channelLabelKey = type => `ct_type_${CHANNEL_TYPES.includes(type) ? type : "other"}`;

/** Where a channel's value links, or null for plain text. */
export function channelHref(channel) {
  const value = String(channel.value || "").trim();
  if (!value) return null;
  if (channel.channel_type === "phone" || channel.channel_type === "viber") return `tel:${value.replace(/[^\d+]/g, "")}`;
  if (channel.channel_type === "email") return `mailto:${value}`;
  if (channel.channel_type === "website") return /^https?:\/\//i.test(value) ? value : `https://${value}`;
  return null;
}
